import moment from 'moment';

export const Utils = {
    isEmpty(v) {
        if (v === null || v === undefined || v === '') {
            return true;
        }
        return false;
    },
    isNumber(evt) {
        evt = evt || window.event;
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (
            charCode > 31 &&
            (charCode < 48 || charCode > 57) &&
            charCode !== 46
        ) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    getPureNumber(num) {
        num = num === '' ? 0 : num;
        return parseInt(num.toString().replace(/[,-]/g, ''));
    },
    getNumberFormat(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getSelectFormObjectFromArray(
        dataFieldName,
        valueFieldName,
        list,
        defaultData = '',
        defaultValue = ''
    ) {
        // array에서 select-form 객체를 위한 object를 추출함
        const resultObject = {
            data: [],
            value: [],
        };

        if (defaultData != '') {
            resultObject.data.push(defaultData);
            resultObject.value.push(defaultValue);
        }

        for (const item of list) {
            if (dataFieldName in item && valueFieldName in item) {
                resultObject.data.push(item[dataFieldName]);
                resultObject.value.push(item[valueFieldName]);
            }
        }

        return resultObject;
    },
    sumFromListByFieldName(list, fieldName) {
        let sum = 0;

        for (const item of list) {
            if (Utils.isEmpty(item[fieldName])) {
                continue;
            }

            sum += parseInt(item[fieldName]);
        }

        return sum;
    },
    getPaymentTypeName(paymentType) {
        const type = {
            C: '카드',
            L: '현금',
            B: '계좌이체',
            M: '마일리지',
            E: '기타',
            T: '핏페이',
            U: '핏페이',
            K: '키오스크',
        };
        return type[paymentType] !== undefined ? type[paymentType] : '--';
    },
    getTicketTypeName(ticketType) {
        if (this.isEmpty(ticketType)) {
            return '--';
        }

        const type = {
            P: '개인',
            D: '듀엣',
            O: 'OT',
            G: '그룹',
            C: '쿠폰',
            T: '회원권',
            S: '운동복',
        };

        return type[ticketType] !== undefined ? type[ticketType] : '--';
    },
    getAttendanceStatusName(status) {
        if (this.isEmpty(status)) {
            return '-';
        }

        const statusName = {
            '-': '출석미승인',
            O: '출석',
            I: '입장',
            X: '결석',
            W: '대기',
        };

        return statusName[status] !== undefined ? statusName[status] : '--';
    },
    getBillStatusString(billStatus) {
        switch (billStatus) {
            case 'O':
                return '정산승인';
            case 'X':
                return '정산취소';
            case '-':
                return '정산미승인';
        }
    },
    getPaymentString(str, joinStr = '<br/>') {
        if (this.isEmpty(str)) {
            return '';
        }

        const strArr = [];
        const arr = str.split('|');

        for (const payment of arr) {
            let [paymentType, amount] = payment.split('_');

            amount = Utils.getNumberFormat(amount);
            paymentType = Utils.getPaymentTypeName(paymentType);

            strArr.push(`[${paymentType}] ${amount} 원`);
        }

        return strArr.join(joinStr);
    },
    isDateInRange(date, startDate, endDate) {
        // date가 startDate와 endDate사이에 있는지 판단
        const sd = moment(startDate);
        const ed = moment(endDate);
        const dt = moment(date);

        return dt.isBetween(sd, ed) || dt.isSame(sd) || dt.isSame(ed);
    },
    getDayOfWeekName(date, format = 'YYYY-MM-DD') {
        const wName = ['일', '월', '화', '수', '목', '금', '토'];
        return wName[moment(date, format).weekday()];
    },
    getAWeekdays(
        date,
        start = 0,
        nameFormat = 'YYYY-MM-DD',
        valueFormat = 'YYYY-MM-DD'
    ) {
        const weekdays = [];
        const d = moment(date, 'YYYY-MM-DD').startOf('week');

        if (start > 0) {
            d.add(start, 'days');
        }

        const wName = ['일', '월', '화', '수', '목', '금', '토'];

        for (let i = 0; i < 7; i++) {
            weekdays.push({
                weekday: wName[(i + start) % 7],
                name: d.format(nameFormat),
                value: d.format(valueFormat),
            });

            d.add(1, 'days');
        }

        return weekdays;
    },
    alertResponseErrorMessge(
        error,
        defaultErrorMessage = '오류가 발생하였습니다'
    ) {
        if (
            !Utils.isEmpty(error.response) &&
            !Utils.isEmpty(error.response.data) &&
            !Utils.isEmpty(error.response.data.message)
        ) {
            alert(error.response.data.message);
        } else {
            alert(defaultErrorMessage);
        }
    },
    getHourList() {
        const hourList = [];
        for (let h = 0; h < 24; h++) {
            hourList.push(h.toString().padStart(2, '0'));
        }
        return hourList;
    },
    getMinsList(minInterval = 10) {
        const minList = [];

        for (let m = 0; m < 60; m += minInterval) {
            minList.push(m.toString().padStart(2, '0'));
        }

        return minList;
    },
    getHourMinutes(value) {
        if (value === null || value === '' || value === undefined) {
            return value;
        }
        let dates = value.split('T');
        if (dates.length === 0) {
            dates = value.split(' ');
        }

        const times = dates.length === 1 ? dates[0] : dates[1];

        const arr = times.split(':');

        return `${arr[0]}:${arr[1]}`;
    },
    getYmd(value, delimiter = '-') {
        if (value === null || value === '' || value === undefined) {
            return value;
        }
        let dates = value.split('T');
        if (dates.length === 0) {
            dates = value.split(' ');
        }

        if (Utils.isEmpty(delimiter) || delimiter === '-') {
            return dates[0];
        }
        return dates[0].replace(/-/g, delimiter);
    },
    getRandomNumber(len = 4) {
        const num = Math.floor(Math.random() * 10 ** len);
        return num.toString().padStart(len, '0');
    },
    getTimes(s, e, gap = 1, lessonTime = 0) {
        const st = moment(s.substring(0, 5), 'HH:mm');
        const et = moment(e.substring(0, 5), 'HH:mm');
        if (lessonTime > 0) {
            st.add(-lessonTime + gap, 'minutes');
        }

        const times = [];
        for (let m = st; m.diff(et, 'minutes') < 0; m.add(gap, 'minutes')) {
            times.push(m.format('HH:mm'));
        }
        return times;
    },
    getSort(data, sortTarget) {
        const patternNumber = /[0-9]/;
        const patternAlphabet = /[a-zA-Z]/;
        const patternHangul = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
        const orderLevelDesc = [patternAlphabet, patternHangul, patternNumber];
        // 배열의 역순으로 정렬이 된다.

        const getLevel = (s) => {
            const index = orderLevelDesc.findIndex((pattern) =>
                pattern.test(s)
            );
            return index;
        };

        const sortGroupString = (source, target) => {
            source.sort((o1, o2) => {
                const a = o1[target].trim();
                const b = o2[target].trim();
                const aLevel = getLevel(a.charAt(0));
                const bLevel = getLevel(b.charAt(0));
                if (aLevel === bLevel) {
                    return a < b ? -1 : 1;
                }
                return bLevel - aLevel; // 오름 차순 정렬
            });
            return source;
        };

        return sortGroupString(data, sortTarget);
    },
    splitContactNumber(no, type = 'contact'){
        let result = ['', '', '']
        if (no === null) return result;

        const length = no.length;
        if (type == 'contact') {
            if (length == 11 && no.substr(0, 2) != '02') { // 010-1234-1234
                result[0] = no.substr(0, 3);
                result[1] = no.substr(3, 4);
                result[2] = no.substr(7, 4);
            } else if (length == 10 && no.substr(0, 2) != '02') { // 031-123-4567
                result[0] = no.substr(0, 3);
                result[1] = no.substr(3, 3);
                result[2] = no.substr(6, 4);
            } else if (length == 10 && no.substr(0, 2) == '02') { // 02-1234-4567
                result[0] = no.substr(0, 2);
                result[1] = no.substr(2, 4);
                result[2] = no.substr(6, 4);
            } else if (length == 9 && no.substr(0, 2) == '02') { // 02-123-4567
                result[0] = no.substr(0, 2);
                result[1] = no.substr(2, 3);
                result[2] = no.substr(5, 4);
            }
        } else if (type == 'tel') {
            if (length == 11 && no.substr(0, 2) != '02') {
                result[0] = no.substr(0, 3);
                result[1] = no.substr(3, 4);
                result[2] = no.substr(7, 4);
            } else if (length == 10 && no.substr(0, 2) != '02') {
                result[0] = no.substr(0, 3);
                result[1] = no.substr(3, 3);
                result[2] = no.substr(6, 4);
            } else if (length == 10 && no.substr(0, 2) == '02') {
                result[0] = no.substr(0, 2);
                result[1] = no.substr(2, 4);
                result[2] = no.substr(6, 4);
            } else if (length == 9 && no.substr(0, 2) == '02') {
                result[0] = no.substr(0, 2);
                result[1] = no.substr(2, 3);
                result[2] = no.substr(5, 4);
            } else if (length == 8) { // 국번이 없는경우
                result[0] = '';
                result[1] = no.substr(0, 4);
                result[2] = no.substr(4, 4);
            }
        } else if (type == 'fax') {
            if (length == 11 && no.substr(0, 2) != '02') {
                result[0] = no.substr(0, 3);
                result[1] = no.substr(3, 4);
                result[2] = no.substr(7, 4);
            } else if (length == 10 && no.substr(0, 2) != '02') {
                result[0] = no.substr(0, 3);
                result[1] = no.substr(3, 3);
                result[2] = no.substr(6, 4);
            } else if (length == 10 && no.substr(0, 2) == '02') {
                result[0] = no.substr(0, 2);
                result[1] = no.substr(2, 4);
                result[2] = no.substr(6, 4);
            } else if (length == 9 && no.substr(0, 2) == '02') {
                result[0] = no.substr(0, 2);
                result[1] = no.substr(2, 3);
                result[2] = no.substr(5, 4);
            }
        }

        return result;
    },
    formatCardNumber(number) {
        if (number === null || number === '' || number === undefined) {
            return number;
        }
    
        const str = String(number)
        return `${str.slice(0, 4)}-${str.slice(4, 8)}-${str.slice(8, 12)}-${str.slice(12, 16)}`
    },
    formatNumber(number) {
        return new Intl.NumberFormat().format(value);
    },
    getFileFromRawImageData(rawImageData) {
        let dataUrl = rawImageData.split(',')
        let base64 = dataUrl[1];
        let mime = dataUrl[0].match(/:(.*?);/)[1];
        let bin = atob(base64);
        let length = bin.length;
        let buf = new ArrayBuffer(length);
        let arr = new Uint8Array(buf);
        bin.split('')
        .forEach((e,i)=>arr[i]=e.charCodeAt(0));

        let f = new File([buf],'signature.' + mime.split("/")[1],{type:mime});

        return f;
    },
     getFirstAndLast(arr) {
        // 배열이 비어있을 경우
        if (arr.length === 0) {
            return { first: undefined, last: undefined };
        }
          
        // 첫 번째 요소와 마지막 요소 가져오기
        const first = arr[0]; // 첫 번째 요소

        if (arr.length === 1) {
            return { first: first, last: first };
        }

        const last = arr[arr.length - 1]; // 마지막 요소


    
        return { first, last };
    },
     getFirstMondayOfWeek(date) {
        return moment(date, 'YYYY-MM-DD') .day() === 0
            ? moment(date).subtract(6, 'days').format('YYYY-MM-DD')  // 일요일이면 6일 전
            : date;
     }
};
